<template>
    <section class="tw:mb-8">
        <h2 class="tw:text-lg tw:font-semibold tw:mb-4">{{ t('simpatizantes.pago_titulo') }}</h2>

        <!-- Error de cancelación (DELETE fallido): visible en el paso 3 para
             que el usuario sepa que el carrito sigue activo y pueda
             reintentar la cancelación. -->
        <b-alert v-if="error" variant="danger" show class="tw:mb-4 tw:whitespace-pre-line">
            {{ error }}
        </b-alert>

        <!-- Formulario CECABANK / Redsys (inyectado, auto-submit) -->
        <div
            v-if="hayFormulario"
            id="formulario-compra"
            ref="formularioContainer"
            class="tw:hidden"
            v-html="formularioPago"
        ></div>

        <!-- Pago vía Paycomet (jet_id) -->
        <PagoPaycometComponent
            v-else-if="hayJetId"
            :jet_id="jetId"
            :session_id="sessionId"
            tipo_venta="sga"
            @compraFinalizada="(e) => $emit('compra-finalizada', e)"
            @error="(e) => $emit('error', e)"
        />
    </section>
</template>
    <script setup>
    import PagoPaycometComponent from '@/components/frontend/compra/components/PagoPaycometComponent.vue';
    import { t } from '@/utils/i18n-helper';
    import { ref, computed, onMounted, nextTick } from 'vue';

    const props = defineProps({
        jetId: { type: String, default: null },
        formularioPago: { type: String, default: null },
        sessionId: { type: String, default: null },
        error: { type: String, default: null },
    });
    defineEmits(['compra-finalizada', 'error']);

    const hayFormulario = computed(() => !!props.formularioPago);
    const hayJetId = computed(() => !!props.jetId);
    const formularioContainer = ref(null);

    // Auto-submit del formulario Redsys/CECABANK inyectado por el backend.
    // El HTML viene de nuestro propio backend (proxy de confianza); solo lo
    // localizamos y enviamos, como hace ProcesoCompraSinRecinto con
    // #formulario-compra. El usuario es redirigido al TPV.
    onMounted(() => {
        if (!hayFormulario.value) return;
        nextTick(() => {
            const form = formularioContainer.value?.querySelector('form');
            if (form) form.submit();
        });
    });
</script>
